import { HTTPRequestMethods } from "../../Shared/httpRequestMethods";
import { parseJsonResponse } from "../../Shared/parseJsonResponse";

export const getUserMatchScores = ({ userId, pageNumber, sortBy, sortDirection, gapFilter, onResponse, onError }) => {
  const params = new URLSearchParams({
    user_id: userId,
    page_number: pageNumber,
    ...(sortBy && { sort_by: sortBy }),
    ...(sortDirection && { sort_direction: sortDirection }),
    ...(gapFilter && { gap_filter: gapFilter }),
  });
  fetch(
    `/api/job_prospects_stats/user_match_scores?${params}`,
    {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};

export const createJobProspectFromMatchScore = ({ body, onResponse, onError }) => {
  fetch(
    `/api/job_prospects_stats/create_job_prospect_from_match_score`,
    {
      method: HTTPRequestMethods.POST,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    }
  )
  .then(response => {
    parseJsonResponse({ response, onResponse, onError });
  })
  .catch((error) => {
    onError({
      feedbackMessage: error.message,
      feedbackVariant: "error",
    });
  });
};
